import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { Menu, Phone, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: "Home", href: "/" },
    { name: "Loan Programs", href: "/loan-programs" },
    { name: "Our Team", href: "/team" },
    { name: "Calculators", href: "/calculators" },
  ];

  const resourcesMenu = [
    { name: "Events", href: "/events" },
    { name: "Education", href: "/education" },
  ];

  const isActive = (path) => location.pathname === path;
  const isResourcesActive = () => resourcesMenu.some(item => location.pathname === item.href);

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_a8f39fa2-260f-4b5d-ae2d-449c88927f46/artifacts/0c714myo_high%20res%20logo%20cropped.png" 
              alt="Pathway Home Lending" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-medium transition-colors hover:text-[#0b2c4a] ${
                  isActive(item.href) 
                    ? "text-[#0b2c4a] border-b-2 border-[#0b2c4a]" 
                    : "text-[#545454]"
                }`}
              >
                {item.name}
              </Link>
            ))}
            
            {/* Resources Dropdown */}
            <DropdownMenu>
              <DropdownMenuTrigger className={`flex items-center space-x-1 text-sm font-medium transition-colors hover:text-[#0b2c4a] ${
                isResourcesActive() 
                  ? "text-[#0b2c4a] border-b-2 border-[#0b2c4a]" 
                  : "text-[#545454]"
              }`}>
                <span>Resources</span>
                <ChevronDown className="h-4 w-4" />
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-48">
                {resourcesMenu.map((item) => (
                  <DropdownMenuItem key={item.name} asChild>
                    <Link 
                      to={item.href}
                      className="w-full cursor-pointer hover:text-[#0b2c4a]"
                    >
                      {item.name}
                    </Link>
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          </nav>

          {/* Contact Info & CTA */}
          <div className="hidden md:flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-sm text-[#545454]">
              <Phone className="h-4 w-4" />
              <span>(720) 650-7988</span>
            </div>
            <Button 
              className="bg-[#0b2c4a] hover:bg-[#0b2c4a]/90 text-white"
              asChild
            >
              <a href="https://pathway.my1003app.com/1225189/register?time=1757968235693" target="_blank" rel="noopener noreferrer">Get Started</a>
            </Button>
          </div>

          {/* Mobile Menu */}
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild className="md:hidden">
              <Button variant="ghost" size="icon">
                <Menu className="h-5 w-5" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px]">
              <div className="flex flex-col space-y-4 mt-8">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`text-lg font-medium transition-colors hover:text-[#0b2c4a] ${
                      isActive(item.href) ? "text-[#0b2c4a]" : "text-[#545454]"
                    }`}
                    onClick={() => setIsOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))}
                
                <div className="border-t pt-4">
                  <div className="text-lg font-medium text-[#545454] mb-2">Resources</div>
                  {resourcesMenu.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={`block text-base font-medium transition-colors hover:text-[#0b2c4a] mb-2 ml-4 ${
                        isActive(item.href) ? "text-[#0b2c4a]" : "text-[#545454]"
                      }`}
                      onClick={() => setIsOpen(false)}
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
                
                <div className="pt-4 border-t">
                  <div className="flex items-center space-x-2 text-[#545454] mb-4">
                    <Phone className="h-4 w-4" />
                    <span>(720) 650-7988</span>
                  </div>
                  <Button 
                    className="w-full bg-[#0b2c4a] hover:bg-[#0b2c4a]/90 text-white"
                    asChild
                    onClick={() => setIsOpen(false)}
                  >
                    <a href="https://pathway.my1003app.com/1225189/register?time=1757968235693" target="_blank" rel="noopener noreferrer">Get Started</a>
                  </Button>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;